"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_redux_1 = require("react-redux");
const selectors_1 = require("@/store/ducks/evaluators/selectors");
const evaluators_1 = require("@/store/ducks/evaluators");
const index_view_1 = __importDefault(require("./index.view"));
function EvaluatorsToast() {
    const dispatch = (0, react_redux_1.useDispatch)();
    const evaluatorsToastStatus = (0, react_redux_1.useSelector)(selectors_1.evaluatorsToastStatusSelector);
    react_1.default.useEffect(() => {
        let close = undefined;
        if (evaluatorsToastStatus?.isOpen) {
            close = setInterval(() => {
                dispatch((0, evaluators_1.closeEvaluatorToast)());
            }, 3000);
        }
        return () => clearInterval(close);
    }, [evaluatorsToastStatus?.isOpen, evaluatorsToastStatus, dispatch]);
    const onClose = react_1.default.useCallback((event, reason) => {
        if (reason === "clickaway") {
            dispatch((0, evaluators_1.closeEvaluatorToast)());
        }
    }, [evaluators_1.closeEvaluatorToast, dispatch]);
    return (react_1.default.createElement(index_view_1.default, { isOpen: Boolean(evaluatorsToastStatus?.isOpen), onClose: onClose, severity: evaluatorsToastStatus?.status, anchorOrigin: { horizontal: "right", vertical: "top" }, message: evaluatorsToastStatus?.message }));
}
exports.default = EvaluatorsToast;
